import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { CRM_PROJECT_ATTACHMENTS } from "app_config";
import PropTypes from "prop-types";

const UploadDocumentDirect = ({uploadDocument}) => {
 
  const onDrop = useCallback((acceptedFiles) => {
    const data = {
      documents: acceptedFiles
    }

    uploadDocument(data)
  }, [uploadDocument])

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    accept: CRM_PROJECT_ATTACHMENTS,
    multiple: true
  })

  return (
    <div>
      <div className="tw-mb-2 tw-text-xs tw-text-blue-600">Only .EML, DWG, PDF, EXCEL, WORD files are allowed. The file size is maximum of 500Mb</div>
      <div {...getRootProps({ className: 'dropzone-area tw-py-6' })}>
        <input {...getInputProps()} />
        <div className="tw-flex tw-justify-center">
          <img src={cloudUpload} alt="Upload Icon" width={25} className="tw-mr-2" />
          <p className="tw-text-base tw-mb-0 tw-text-slate-700">Drop your files here</p>
        </div>
      </div>
    </div>
  )
}

UploadDocumentDirect.propTypes = {
  uploadDocument: PropTypes.func.isRequired,
};

export default UploadDocumentDirect;